class WarehouseListCell extends UITableViewCell
{
    private nameLabel:MUILabel = null;
    
    awakeFromHTML(){
        this.nameLabel = MUIOutlet(this, 'name-lbl', 'MUILabel');            
    }
    
    set item(i:Warehouse){
        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
        this.nameLabel.text = i.name + (i.placeID != null && i.placeID.toLowerCase() != ad.selectedIdentifier.toLowerCase() ? " 🔒" : "" );
    }
}
